export default __webpack_public_path__ + "static/media/2x_Collage.63241c65.png";